import { useCallback, useEffect, useRef, useState } from 'react'

import { streamaxHost } from '~/config'
import useAuth from '~/utils/auth/useAuth'

const useHooks = () => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const videoRef2 = useRef<HTMLVideoElement>(null)
  const { token } = useAuth()
  const [videoSrc, setVideoSrc] = useState([])
  const [streamType, setStreamType] = useState('1')
  const [controls, setControls] = useState(true)
  const [mediaUrl, setMediaUrl] = useState('')

  const handleStreamTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setStreamType(event.target.value)
  }

  const getLiveLinks = useCallback(async () => {
    try {
      const res = await fetch(
        `${streamaxHost}/webhook/streamax-livestream-url`,
        {
          method: 'POST',
          headers: {
            _sign:
              'c84a9839246166e3675a29354673dd4dc98020a9e76b517fce7e587ba62d91e79fb22d8ef22827fee6d2567a324b28c32876a8c51319d47d2bf331b591e415b6849c24a0356489fb52ee2f269c489e0e8b568d47344952ef49663674952daa447e0765035d40a16f6f179ba1adb28c6bdf302670c1e9b96f3dae217fc208995b2bc4d28eff3892eab8b2c0fa4e184d4c53348a3687716128652f0c78b3f72338',
            _tenantid: '1205',
            Authorization: `Bearer ${token}`,
          },
        }
      )

      if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`)
      }

      const data = await res.json()
      setVideoSrc(data?.[0]?.data)
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error fetching live links:', err)
      throw err
    }
  }, [])

  const handleLoadMediaUrl = useCallback(async () => {
    try {
      const res = await fetch(
        `${streamaxHost}/webhook/a304383d-b374-4199-8128-2d2f747abc04`
      )
      if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`)
      }
      const data = await res.json()
      setMediaUrl(data?.[0]?.data?.mediaUrl)
    } catch {
      // eslint-disable-next-line no-console
      console.error('Error fetching media url')
    }
  }, [])

  const handleStart = useCallback(() => {
    if (streamType === '1') {
      getLiveLinks()
      setMediaUrl(null)
      videoRef.current?.load()
      videoRef2.current?.load()
      videoRef.current?.play()
      videoRef2.current?.play()
      setControls(true)
      return
    }
    // Reset mediaUrl supaya polling mulai segar
    setMediaUrl(null)
    videoRef.current?.pause()
    videoRef2.current?.pause()
    handleLoadMediaUrl()
    setControls(false)
  }, [streamType, handleLoadMediaUrl])

  useEffect(() => {
    getLiveLinks()
  }, [])

  return {
    videoRef,
    videoRef2,
    data: {
      videoSrc,
      streamType,
      controls,
      mediaUrl,
    },
    methods: {
      setVideoSrc,
      handleStreamTypeChange,
      handleStart,
    },
  }
}

export default useHooks
